/**
 * `/` — R11 #649: every role landed on the Apps portal. R-14 T-068/T-087: below Expert the portal is
 * not a destination — a business user opens straight into the first app's home for their scope (the
 * department's investment plan); at Expert the portal stays the front door.
 */
import { Navigate } from 'react-router-dom';
import { appOpenPath, useApps } from '@/features/apps/apps-api';
import { RouteFallback } from '@/app/shell/RouteFallback';
import { EXPERT } from '@/app/experience/tiers';
import { useExperience } from '@/app/experience/ExperienceProvider';

export function HomeIndex() {
  const { tier, ready } = useExperience();
  const apps = useApps();
  if (!ready) return <RouteFallback />;
  if (tier >= EXPERT) return <Navigate to="/apps" replace />;
  if (apps.isLoading) return <RouteFallback />;
  const first = apps.data?.apps[0];
  return <Navigate to={first ? appOpenPath(first) : '/apps'} replace />;
}
